// extracted by mini-css-extract-plugin
export default {"shadow":"login_shadow__5O+zn","border":"login_border__-wmnM","wrapper":"login_wrapper__0N2YV","bar":"login_bar__fjjjS","split":"login_split__JXeNm","error":"login_error__BttE1"};